import type { PdfSection } from '@utils/downloadHtmlAsPdf';
import { domToPng } from 'modern-screenshot';

export const PDF_SECTION_ATTR = 'data-pdf-section';

const TRANSPARENT_PIXEL =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

const secureFetchFn = async (url: string): Promise<string | false> => {
  if (url.startsWith('data:')) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin === window.location.origin) return false;
    return TRANSPARENT_PIXEL;
  } catch {
    return TRANSPARENT_PIXEL;
  }
};

const captureElement = (element: HTMLElement) =>
  domToPng(element, {
    scale: 2,
    backgroundColor: '#ffffff',
    fetchFn: secureFetchFn,
    font: {},
    timeout: 30000,
    features: { removeAbnormalAttributes: true },
  });

export const captureSections = async (
  sections: HTMLElement[],
  options?: { pageBreakBeforeIndex?: number },
): Promise<PdfSection[]> => {
  await document.fonts.ready;
  const pageBreakBeforeIndex = options?.pageBreakBeforeIndex ?? 1;
  const images = await Promise.all(sections.map(captureElement));
  return images.map((dataUrl, i) => ({
    dataUrl,
    startsNewPage: i === pageBreakBeforeIndex,
  }));
};
